var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-container", { staticClass: "px-3 mt-4" }, [
        _c(
          "div",
          [
            _c(
              "search",
              { attrs: { show_all_mvm: true }, on: { onSearch: _vm.onSearch } },
              [
                _vm.$route.meta.action.e
                  ? _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c("ExportExcel", {
                          attrs: {
                            "export-data": _vm.exportData,
                            columns: _vm.columns,
                            filename: _vm.excel_filename,
                          },
                          on: {
                            onExportClick: _vm.onExportClick,
                            clearData: function ($event) {
                              _vm.exportData.rows = null
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, lg: 24 } }, [
            _vm.loaded
              ? _c(
                  "div",
                  { staticClass: "chart-wrapper" },
                  [
                    _c("bar-chart", {
                      attrs: {
                        "chart-data": _vm.chartData,
                        title: "銷售彙總",
                        label: _vm.chartLabels,
                        height: "35vh",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.is_loading,
              expression: "is_loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.mvms,
            stripe: "",
            "default-sort": { prop: "asset_no", order: "aescending" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "asset_no",
              label: "機台編號",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "company_name", label: "經銷商", width: "160" },
          }),
          _c("el-table-column", {
            attrs: { prop: "customer_name", label: "客戶名稱", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "location_name", label: "擺放位置", width: "120" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "product_total_volume",
              label: "銷售數量",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total_amount",
              label: "銷售總金額",
              width: "120",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "cash_amount",
              label: "現金",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "easycard_amount",
              label: "悠遊卡",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ipass_amount",
              label: "一卡通",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "linepay_amount",
              label: "LinePay",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "linepay_ipass_amount",
              label: "LinePay一卡通",
              width: "140",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pi_amount",
              label: "Pi行動錢包",
              width: "120",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "alipay_amount",
              label: "支付寶",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "jkos_amount",
              label: "街口",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "gamapay_amount",
              label: "橘子支",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "taiwanpay_amount",
              label: "台灣Pay",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "esunwallet_amount",
              label: "玉山錢包",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pluspay_amount",
              label: "全盈支付",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pxpayplus_amount",
              label: "全支付",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "easycard_esun_amount",
              label: "悠遊付",
              width: "100",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "creditcard_amount",
              label: "信用卡",
              width: "100",
              sortable: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }